export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    jQuery('.home-slider').slick({arrows:false, autoplay: true, autoplaySpeed: 4000});
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js